import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import s from './AddWarehouseButton.module.css';
import sg from '../../../styles/index.module.css';
import { Overlay } from '../Overlay/Overlay';
import { AddWarehouseModal } from '../AddWarehouseModal/AddWarehouseModal';
import { sendAddWarehouseRequest } from '../../store/slices/boardSlice';

export class AddWarehouseButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isWarehouseAddingMode: false,
            isNewWarehouse: false,
            isDrawInput: false,
            inputValue: i18next.t('AddWarehouseButton.constructor.inputValue'),
            needOpenAvailableForAttachmentProjectListOnLeft: false,
        };
        this.ref = React.createRef();
        this.onClick = this.onClick.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.saveNewWarehouse = this.saveNewWarehouse.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.disableWarehouseAddingMode = this.disableWarehouseAddingMode.bind(this);
        this.setWarehouseCreatingMode = this.setWarehouseCreatingMode.bind(this);
    }

    onClick() {
        this.ref.current.scrollIntoView(false);
        const rect = this.ref.current.getBoundingClientRect();
        this.setState({
            isWarehouseAddingMode: true,
            isNewWarehouse: false,
            isDrawInput: false,
            isProjectSelectMode: true,
            top: rect.top,
            left: rect.left,
            height: rect.height,
        });
        if (document.documentElement.clientWidth - rect.left - rect.width < 100) {
            this.setState({
                needOpenAvailableForAttachmentProjectListOnLeft: true,
            });
        } else {
            this.setState({
                needOpenAvailableForAttachmentProjectListOnLeft: false,
            });
        }
    }

    onInputChange(e) {
        this.setState({
            isDrawInput: true,
            inputValue: e.target.value,
        });
        if (e.target.value.trim() === '') {
            this.clearInputValue();
        }
    }

    onKeyDown(e) {
        if (e.key === 'Enter') {
            this.saveNewWarehouse();
            this.setState({
                isWarehouseAddingMode: false,
            });
        }
    }

    setWarehouseCreatingMode(mode) {
        if (mode === 'project') {
            this.setState({
                isProjectSelectMode: true,
                isDrawInput: false,
                isNewWarehouse: false,
            });
        } else if (mode === 'custom') {
            this.setState({
                isProjectSelectMode: false,
                isDrawInput: true,
                isNewWarehouse: true,
            });
        } else {
            window.console.log('Error');
        }
        this.clearInputValue();
    }

    clearInputValue() {
        this.setState({
            inputValue: i18next.t('AddWarehouseButton.clearInputValue.inputValue'),
        });
    }

    saveNewWarehouse() {
        this.props.addWarehouse({
            title: this.state.inputValue,
        });
        this.clearInputValue();
    }

    disableWarehouseAddingMode() {
        this.setState({
            isWarehouseAddingMode: false,
        });
    }

    render() {
        const { addWarehouse, filterValue } = this.props;

        return (
            <>
                {!filterValue.length && (
                    <div
                        className={s.addWarehouseButtonWrapper}
                        data-id="add-warehouse-button"
                        onClick={this.onClick}
                        ref={this.ref}
                    >
                        <div className={s.addWarehouseButton}>
                            <span>
                                {i18next.t('AddWarehouseButton.render.text')}
                            </span>
                        </div>
                    </div>
                )}

                {this.state.isWarehouseAddingMode && (
                    <Overlay
                        onClick={() => {
                            this.disableWarehouseAddingMode();
                            if (!this.state.isProjectSelectMode) {
                                this.saveNewWarehouse();
                            }
                        }}
                    >
                        <div
                            style={{
                                position: 'fixed',
                                left: this.state.left,
                                top: this.state.top,
                                height: this.state.height,
                            }}
                            className={s.addWarehouseModal}
                        >
                            <div className={s.addNewWarehouseButton}>
                                {!this.state.isNewWarehouse && !this.state.isDrawInput && (
                                    <span className={s.addNewWarehouseButtonTitle}>
                                        {this.state.inputValue}
                                    </span>
                                )}
                                {this.state.isNewWarehouse && this.state.isDrawInput && (
                                    <input
                                        data-id="new-warehouse-input"
                                        className={sg.input}
                                        maxLength="255"
                                        placeholder={i18next.t('AddWarehouseButton.render.input.inputValue')}
                                        defaultValue={this.state.inputValue}
                                        onChange={this.onInputChange}
                                        onKeyDown={this.onKeyDown}
                                        autoFocus
                                        onFocus={(event) => event.target.select()}
                                    />
                                )}
                                <AddWarehouseModal
                                    disableWarehouseAddingMode={this.disableWarehouseAddingMode}
                                    setWarehouseCreatingMode={this.setWarehouseCreatingMode}
                                    addWarehouse={addWarehouse}
                                    isLeftModeModal={
                                        this.state.needOpenAvailableForAttachmentProjectListOnLeft
                                    }
                                />
                            </div>
                        </div>
                    </Overlay>
                )}
            </>
        );
    }
}

export function AddWarehouseButtonContainer(props) {
    const dispatch = useDispatch();
    const addWarehouse = useCallback(
        (payload) => {
            dispatch(sendAddWarehouseRequest(payload));
        },
        [dispatch]
    );
    const filterValue = useSelector((state) => state.filter);
    const hasFullAccess = useSelector((state) => state.restrictions);

    return (
        <AddWarehouseButton
            {...props}
            addWarehouse={addWarehouse}
            filterValue={filterValue}
            hasFullAccess={hasFullAccess}
        />
    );
}
